import { Operadora } from './operadora.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class OperadoraService {

    constructor(private http: Http) {
    }

    getOperadoras(): Observable<Operadora[]> {
        return this.http.get(`${NTECH_API}/operadora`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/operadora/operadora.service.ts